// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__2BiUa","content":"styles_content__38sou","checkbox":"styles_checkbox__3BB-j","checkboxLabel":"styles_checkboxLabel__2d_Ye"};